export const TESTIMONIALS = [
  {
    quote: "सीट तीन बार हारी थी। Onward की team ने booth-level data और रोज़ के war room से narrative बदल दिया। 22 हज़ार से जीते।",
    name: "Vidhayak",
    role: "Vidhan Sabha Candidate, Malwa",
    tag: "Political Campaign",
  },
  {
    quote: "Every attack was answered within the hour. The reels factory produced more in a day than our previous agency did in a month.",
    name: "Campaign In-charge",
    role: "Lok Sabha War Room, Central India",
    tag: "Digital War Room",
  },
  {
    quote: "Indore के 85 wards में हर मोहल्ले तक पहुँच बनी। Door-to-door app से पहली बार पता चला कि कौन सा booth कमज़ोर है।",
    name: "Mahapaur Candidate",
    role: "Indore Nagar Nigam",
    tag: "Ground Outreach",
  },
  {
    quote: "Site visits tripled in the first quarter. They understood Indore buyers better than our own sales team.",
    name: "Director",
    role: "Real Estate Developer, Super Corridor",
    tag: "Brand & Corporate",
  },
];

export const SECTORS = [
  "Political Parties",
  "Candidates & Leaders",
  "Government & PSUs",
  "Real Estate",
  "Education",
  "Healthcare",
  "FMCG & Retail",
  "Hospitality",
  "NGOs & Foundations",
];

export const ELECTIONS = [
  { id: "mp-vidhan-sabha", name: "MP Vidhan Sabha", hindi: "मध्य प्रदेश विधानसभा", date: "2028-11-15", note: "Expected · Nov 2028" },
  { id: "lok-sabha", name: "Lok Sabha", hindi: "लोकसभा", date: "2029-04-15", note: "Expected · Apr–May 2029" },
];

export const FAQS = [
  {
    q: "कितने पहले campaign शुरू करना चाहिए?",
    a: "Vidhan Sabha के लिए कम से कम 90 दिन, Lok Sabha के लिए 120 दिन। लेकिन सबसे अच्छे नतीजे उन leaders के आते हैं जो चुनाव से 12–18 महीने पहले अपनी digital presence और ground data पर काम शुरू कर देते हैं।",
  },
  {
    q: "Do you work with both BJP and Congress?",
    a: "Yes. We work with candidates across parties and with independents — but never with two rival candidates in the same constituency. Confidentiality is absolute; we sign NDAs with every client.",
  },
  {
    q: "क्या आप Indore के बाहर भी काम करते हैं?",
    a: "बिल्कुल। Headquarter Indore में है, लेकिन हमारी field teams पूरे मध्य प्रदेश में हैं और हमने Rajasthan, Chhattisgarh, UP, Maharashtra और Gujarat में campaigns किए हैं।",
  },
  {
    q: "What does a package include that a freelancer cannot give?",
    a: "A full war room — strategist, data analyst, editors, ground coordinators and a PR desk — working on one calendar. Freelancers make content; we run campaigns and own the result.",
  },
  {
    q: "Payment terms क्या हैं?",
    a: "Election packages monthly billing पर चलते हैं — 30 दिन advance। Reels और brand packages में 50% advance, 50% delivery पर। सभी prices GST अतिरिक्त।",
  },
  {
    q: "How fast can you start?",
    a: "A reels or social package starts within 72 hours. A Vidhan Sabha war room is on the ground within 10 days of signing — survey teams first, studio second.",
  },
];
